<template>
  <div class="reg-card" :class="[variant && `reg-card--${variant}`, { 'reg-card--center': center }]">
    <button v-if="showBack" class="reg-card-back" @click="$emit('back')">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path d="M19 12H5M12 5l-7 7 7 7"/>
      </svg>
    </button>
    <slot />
  </div>
</template>

<script>
export default {
  name: "RegCard",
  props: {
    variant:  { type: String, default: null },   // 'orange' | null
    center:   { type: Boolean, default: false },
    showBack: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.reg-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 32px 26px;
  width: 100%;
  max-width: 420px;
  box-shadow:
    0 2px 4px rgba(0,0,0,.04),
    0 8px 24px rgba(0,0,0,.10),
    0 24px 64px rgba(0,0,0,.14);
  position: relative;
  font-family: "DM Sans", "Outfit", system-ui, sans-serif;
  border: 1px solid rgba(255,255,255,.9);
}
.reg-card--center { text-align: center; }
.reg-card--orange {
  background: linear-gradient(145deg, #ff9a7a 0%, #ff825d 60%, #e86b45 100%);
  color: #fff;
  border-color: rgba(255,255,255,.2);
}
.reg-card-back {
  background: #f7f4f1;
  border: none;
  cursor: pointer;
  width: 32px; height: 32px;
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  color: #7a736e;
  margin-bottom: 18px;
  transition: all 0.12s;
  .reg-card--orange & { background: rgba(255,255,255,.2); color: #fff; }
  &:hover { background: #f0ece8; color: #1a1210; }
}
</style>
